module.exports = __webpack_public_path__ + "img/软件产品-pow3.3c26f338.png";